import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Principal } from '../../models/principal/principal';
import { Authority } from '../../models/principal/authority';
import { switchMap, tap } from 'rxjs/operators';
import { FabricService } from 'src/app/services/fabric/fabric.service';
import { Permission } from 'src/app/models/principal/permission';
import { PERMISSIONS_MAP } from 'src/app/models/principal/permissions-map';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { RouterSegments } from 'src/app/models/router-segments';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  assignedPermissions: any;
  authorityGroups: any;
  hideToolbar = false;

  private _principal: Principal;

  get principal(): Principal {
    return this._principal;
  }

  set principal(value: Principal) {
    this._principal = value;
  }
  encryptedBase64Key = 'ZmFicmljc2VjcmV0a2V5cw==';

  constructor(private fabricService: FabricService, private router: Router) {

  }

  logout(): void {
    this.keycloakLogout().pipe().subscribe(
      response => {
        this.fabricService.logout();
        window.location.href = `${window.location.origin}/${this.principal.provider}`;
      }
    );
  }

  keycloakLogout(): Observable<any> {
    return this.fabricService.invokeOperation<any>('user-resources', 'post_user-profile_logout');
  }

  login(): any {
    return this.fabricService.login();
  }

  loadPrincipal(): Observable<Principal> {
    return this.fabricService.invokeOperation<Principal>('application-resources', 'get_userinfo')
      .pipe(switchMap((principal) => {
        this.principal = principal;
        if(principal.authorities.length === 0) {
          this.router.navigate(['/', this.principal.provider, 'permission-unauthorized']);
        }
        if (principal?.code) {
          const parsedBase64Key = CryptoJS.enc.Base64.parse(this.encryptedBase64Key);
          const encryptedCipherText = principal?.code;
          const decryptedData = CryptoJS.AES.decrypt(encryptedCipherText, parsedBase64Key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          });
          const decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);

          const authorities = [];
          const jwtService = new JwtHelperService();
          const decode = jwtService.decodeToken(decryptedText);
          const resources = decode.resource_access;
          Object.keys(resources).map((k) => {
            resources['solution-service'].roles.map((x) =>
            authorities.push(x)
            );
          });

          const validItems = authorities.filter((tokenItems) => principal.authorities.some((authItems) => tokenItems === authItems));
          principal.authorities = validItems;

          // const removeDuplicates = [...new Set(principal.authorities)];
          // const roles = removeDuplicates.toString();
          this.principal = principal;
          // if (roles?.length) {
            return this.fabricService.invokeOperation<any>('permission-resources', 'get_authz_role-permissions')
            .pipe(tap((response) => {
              this.assignedPermissions = response.permissions;
            },
            (error) => {
              this.hideToolbar = true;
              this.router.navigate(['/', this.principal.provider, 'permission-unauthorized'], {skipLocationChange:true});
            }));
          // } else {
          //   this.logout();
          // }
        } else {
          this.logout();
        }
      })
    );
  }

  hasPermission(permission: Permission): boolean {
    const authoritiesForPermission = PERMISSIONS_MAP[permission];
    if (this.principal?.authorities) {
      return this.principal.authorities.some(authority => authoritiesForPermission.includes(authority));
    }
  }

  hasAPIPermission(permission: any): boolean {
    if (permission.attribute) {
      return this.assignedPermissions?.find(item => item.action === permission.action && item.attribute === permission.attribute
        && item.attributeValue === permission.attributeValue) ? true : false;
    } else {
      return this.assignedPermissions?.find(item => item.action === permission.action && item.hasOwnProperty('attribute') === false
       && item.hasOwnProperty('attributeValue') === false) ? true : false;
    }
  }

  hasAuthority(givenAuthority: Authority): boolean {
    return this.principal.authorities.includes(givenAuthority);
  }
}
